module.exports = __webpack_public_path__ + "static/media/sd.91e76043.gif";